import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import Redirect from '@/components/Redirect'
import usePermissions from '@/hooks/usePermissions'
import { useNavigate, useParams } from 'react-router-dom'
import PhishEmailTemplateForm from './PhishEmailTemplateForm'

const mapStateToProps = () => ({})

const PhishEmailTemplateCreate = ({ dispatch }) => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const routeParams = useParams()
  const { type } = routeParams

  const canCreate = usePermissions(
    type === 'system' ? 'emailTempSystem_create' : 'emailTempPerson_create',
  )

  const onSubmit = payload => {
    dispatch({
      type: 'emailTemplate/createEmailTemplate',
      payload,
      successCallback: () => {
        dispatch({
          type: 'app/notify',
          payload: { message: t('messages.email_template_created'), severity: 'success' },
        })
        navigate(`/phish_template_email/${type}`, { replace: true })
      },
    })
  }

  if (!canCreate) return <Redirect />

  return <PhishEmailTemplateForm onSubmit={onSubmit} type={type} />
}

export default connect(mapStateToProps)(PhishEmailTemplateCreate)
